import { render, staticRenderFns } from "./EditBanPolicy.vue?vue&type=template&id=96db3de8&"
import script from "./EditBanPolicy.vue?vue&type=script&lang=ts&"
export * from "./EditBanPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports